import { Card, type CardProps } from '@common/ui/Card';

import styles from './PaymentMethodCard.module.scss';

export interface PaymentMethodCardProps extends CardProps {
  name: string;
  sign: React.ReactNode;
}

export const PaymentMethodCard = ({
  name,
  sign,
  ...props
}: PaymentMethodCardProps) => {
  return (
    <Card {...props} className={styles.paymentMethodCard}>
      <div className={styles.sign}>{sign}</div>
      <div className={styles.name}>{name}</div>
    </Card>
  );
};
